import { FEATURE_FLAGS } from '@/constants';
import { IFeatureFlag } from '@/types';

export type RhiVersion = 'v1' | 'v2';

export const resolveRhiVersion = ({
  featureFlags,
  isAgent,
}: {
  featureFlags?: IFeatureFlag[] | null;
  isAgent: boolean;
}): RhiVersion => {
  // Agents launch from the CRM straight into the v2 journey.
  if (isAgent) return 'v2';

  const rhiV2Flag = featureFlags?.find?.(
    (flag) => flag.name === FEATURE_FLAGS.RHI_V2,
  );
  return rhiV2Flag?.enabled === true ? 'v2' : 'v1';
};
